const DB_NAME = "micromarket-pv-offline";
const DB_VERSION = 6;
const STORE_FACTURAS = "facturasPendientes";
const STORE_PRODUCTOS = "productosBusqueda";
const STORE_CATALOGO_PRODUCTOS = "productosCatalogo";
const STORE_CLIENTES = "clientes";
const STORE_ARS = "ars";
const STORE_MENSAJEROS = "mensajeros";
const STORE_TIPOS_TARJETA = "tiposTarjeta";
const STORE_VENDEDORES = "vendedores";

function soportaIndexedDB() {
  return typeof window !== "undefined" && "indexedDB" in window;
}

function abrirDb() {
  return new Promise((resolve, reject) => {
    if (!soportaIndexedDB()) {
      reject(new Error("IndexedDB no esta disponible en este navegador"));
      return;
    }

    const request = window.indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error || new Error("No se pudo abrir IndexedDB"));
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = event => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_FACTURAS)) {
        const store = db.createObjectStore(STORE_FACTURAS, { keyPath: "offlineId" });
        store.createIndex("estado", "estado", { unique: false });
        store.createIndex("fechaLocal", "fechaLocal", { unique: false });
      }
      if (!db.objectStoreNames.contains(STORE_PRODUCTOS)) {
        const store = db.createObjectStore(STORE_PRODUCTOS, { keyPath: "cacheKey" });
        store.createIndex("texto", "texto", { unique: false });
        store.createIndex("sucursal", "sucursal", { unique: false });
      }
      if (!db.objectStoreNames.contains(STORE_CATALOGO_PRODUCTOS)) {
        const store = db.createObjectStore(STORE_CATALOGO_PRODUCTOS, { keyPath: "catalogoKey" });
        store.createIndex("sucursal", "sucursal", { unique: false });
        store.createIndex("texto", "texto", { unique: false });
      }
      if (!db.objectStoreNames.contains(STORE_CLIENTES)) {
        const store = db.createObjectStore(STORE_CLIENTES, { keyPath: "codigo" });
        store.createIndex("nombre", "nombre", { unique: false });
      }
      if (!db.objectStoreNames.contains(STORE_ARS)) {
        const store = db.createObjectStore(STORE_ARS, { keyPath: "codigo" });
        store.createIndex("nombre", "nombre", { unique: false });
      }
      if (!db.objectStoreNames.contains(STORE_MENSAJEROS)) {
        const store = db.createObjectStore(STORE_MENSAJEROS, { keyPath: "codigo" });
        store.createIndex("nombre", "nombre", { unique: false });
        store.createIndex("sucursal", "sucursalKey", { unique: false });
      }
      if (!db.objectStoreNames.contains(STORE_TIPOS_TARJETA)) {
        const store = db.createObjectStore(STORE_TIPOS_TARJETA, { keyPath: "codigo" });
        store.createIndex("nombre", "nombre", { unique: false });
      }
      if (!db.objectStoreNames.contains(STORE_VENDEDORES)) {
        const store = db.createObjectStore(STORE_VENDEDORES, { keyPath: "codigo" });
        store.createIndex("nombre", "nombre", { unique: false });
        store.createIndex("codigo2", "codigo2", { unique: false });
        store.createIndex("sucursal", "sucursalKey", { unique: false });
      }
    };
  });
}

function txStore(db, storeName, mode) {
  return db.transaction(storeName, mode).objectStore(storeName);
}

function requestToPromise(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function normalizarTexto(texto) {
  return (texto || "").toString().trim().toLowerCase();
}


function productoCatalogoKey(producto, sucursal) {
  const codigo = producto && producto.productos && producto.productos.codigo != null ? producto.productos.codigo : "producto";
  const unidad = producto && producto.unidades && producto.unidades.codigo != null ? producto.unidades.codigo : "unidad";
  const lote = producto && producto.codlote != null ? producto.codlote : (producto && producto.lote != null ? producto.lote : "");
  return sucursal + "-" + codigo + "-" + unidad + "-" + lote;
}

function textoProductoBusqueda(producto) {
  const partes = [];
  if (producto && producto.descripcion) partes.push(producto.descripcion);
  if (producto && producto.codigobarra) partes.push(producto.codigobarra);
  if (producto && producto.productos) {
    if (producto.productos.codigo != null) partes.push(producto.productos.codigo.toString());
    if (producto.productos.descripcion) partes.push(producto.productos.descripcion);
    if (producto.productos.descripcioncorta) partes.push(producto.productos.descripcioncorta);
    if (producto.productos.referencia) partes.push(producto.productos.referencia);
    if (producto.productos.codigoanterior) partes.push(producto.productos.codigoanterior);
    if (producto.productos.fabricante && producto.productos.fabricante.nombre) partes.push(producto.productos.fabricante.nombre);
  }
  return normalizarTexto(partes.join(" "));
}

function coincideProducto(producto, filtro) {
  const texto = textoProductoBusqueda(producto);
  if (!filtro) return true;
  return texto.indexOf(filtro) >= 0;
}

function crearOfflineId(meta) {
  const caja = meta && meta.caja && meta.caja.codigo != null ? meta.caja.codigo : "caja";
  return "OFF-" + caja + "-" + Date.now() + "-" + Math.random().toString(36).substr(2, 8);
}

export async function guardarFacturaPendiente(factura, meta) {
  const db = await abrirDb();
  const now = new Date().toISOString();
  const record = {
    offlineId: crearOfflineId(meta),
    estado: "pendiente",
    intentos: 0,
    fechaLocal: now,
    fechaActualizacion: now,
    factura,
    meta: meta || {},
    ultimoError: null,
    facturaServidor: null,
  };
  await requestToPromise(txStore(db, STORE_FACTURAS, "readwrite").put(record));
  db.close();
  return record;
}

export async function obtenerFacturasPendientes() {
  const db = await abrirDb();
  const registros = await requestToPromise(txStore(db, STORE_FACTURAS, "readonly").getAll());
  db.close();
  return registros.filter(item => item.estado === "pendiente" || item.estado === "error").sort((a, b) => a.fechaLocal.localeCompare(b.fechaLocal));
}

export async function marcarFacturaSincronizando(offlineId) {
  const db = await abrirDb();
  const store = txStore(db, STORE_FACTURAS, "readwrite");
  const record = await requestToPromise(store.get(offlineId));
  if (!record || (record.estado !== "pendiente" && record.estado !== "error")) {
    db.close();
    return null;
  }
  record.estado = "sincronizando";
  record.fechaActualizacion = new Date().toISOString();
  await requestToPromise(store.put(record));
  db.close();
  return record;
}

export async function marcarFacturaSincronizada(offlineId, facturaServidor, pendienteElectronico = false) {
  const db = await abrirDb();
  // Esperar el COMMIT de IndexedDB: el recibo del servidor debe sobrevivir al reintento.
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_FACTURAS, "readwrite");
    const store = tx.objectStore(STORE_FACTURAS);
    let existe = false;
    tx.oncomplete = () => {
      db.close();
      if (existe) resolve();
      else reject(new Error("No existe el registro offline para conservar la factura del servidor"));
    };
    tx.onabort = () => { db.close(); reject(tx.error || new Error("No se pudo conservar la factura sincronizada")); };
    const request = store.get(offlineId);
    request.onsuccess = () => {
      const record = request.result;
      if (!record) return;
      existe = true;
      record.estado = pendienteElectronico ? "error" : "sincronizada";
      record.ultimoError = pendienteElectronico ? "Venta guardada; pendiente de registrar XML en el coordinador" : "";
      record.facturaServidor = facturaServidor;
      record.fechaActualizacion = new Date().toISOString();
      store.put(record);
    };
  });
}

export async function marcarFacturaError(offlineId, error) {
  const db = await abrirDb();
  const store = txStore(db, STORE_FACTURAS, "readwrite");
  const record = await requestToPromise(store.get(offlineId));
  if (record) {
    record.estado = "error";
    record.intentos = (record.intentos || 0) + 1;
    record.ultimoError = error ? error.toString() : "Error sincronizando factura";
    record.fechaActualizacion = new Date().toISOString();
    await requestToPromise(store.put(record));
  }
  db.close();
}

export async function guardarProductosBusqueda(cacheKey, texto, sucursal, productos) {
  const db = await abrirDb();
  await requestToPromise(txStore(db, STORE_PRODUCTOS, "readwrite").put({
    cacheKey,
    texto: normalizarTexto(texto),
    sucursal,
    productos: productos || [],
    fechaActualizacion: new Date().toISOString(),
  }));
  db.close();
  await guardarProductosCatalogo(productos || [], sucursal);
}

export async function guardarProductosCatalogo(productos, sucursal) {
  const db = await abrirDb();
  const store = txStore(db, STORE_CATALOGO_PRODUCTOS, "readwrite");
  for (const producto of productos || []) {
    if (producto && producto.productos && producto.productos.codigo != null && producto.unidades && producto.unidades.codigo != null) {
      await requestToPromise(store.put({
        catalogoKey: productoCatalogoKey(producto, sucursal),
        sucursal,
        texto: textoProductoBusqueda(producto),
        producto,
        fechaActualizacion: new Date().toISOString(),
      }));
    }
  }
  db.close();
}

export async function buscarProductosCache(cacheKey, texto, sucursal) {
  const db = await abrirDb();
  const store = txStore(db, STORE_PRODUCTOS, "readonly");
  const exacto = await requestToPromise(store.get(cacheKey));
  if (exacto) {
    db.close();
    return exacto.productos || [];
  }
  const registros = await requestToPromise(store.getAll());
  const filtro = normalizarTexto(texto).replace(/\*-s-\*/g, "/");
  const productos = [];
  const agregados = {};
  registros
    .filter(item => item.sucursal === sucursal)
    .forEach(item => {
      (item.productos || []).forEach(producto => {
        if (coincideProducto(producto, filtro)) {
          const key = productoCatalogoKey(producto, sucursal);
          if (!agregados[key]) {
            agregados[key] = true;
            productos.push(producto);
          }
        }
      });
    });
  if (productos.length > 0) {
    db.close();
    return productos.slice(0, 25);
  }
  const catalogo = await requestToPromise(txStore(db, STORE_CATALOGO_PRODUCTOS, "readonly").getAll());
  db.close();
  catalogo
    .filter(item => item.sucursal === sucursal && coincideProducto(item.producto, filtro))
    .forEach(item => {
      if (!agregados[item.catalogoKey]) {
        agregados[item.catalogoKey] = true;
        productos.push(item.producto);
      }
    });
  return productos.slice(0, 25);
}

export async function guardarClientes(clientes) {
  const db = await abrirDb();
  const store = txStore(db, STORE_CLIENTES, "readwrite");
  for (const cliente of clientes || []) {
    if (cliente && cliente.codigo != null) {
      await requestToPromise(store.put(cliente));
    }
  }
  db.close();
}

export async function contarClientesCache() {
  const db = await abrirDb();
  const total = await requestToPromise(txStore(db, STORE_CLIENTES, "readonly").count());
  db.close();
  return total || 0;
}

function clienteCumpleTipo(cliente, tipoCliente) {
  const tipo = Number(tipoCliente || 3);
  if (cliente && cliente.asArs === true) return false;
  if (tipo === 1) return Number(cliente && cliente.diascredito ? cliente.diascredito : 0) > 0;
  if (tipo === 2) return cliente && cliente.ars != null;
  return true;
}

export async function buscarClientesCache(texto, tipoCliente) {
  const db = await abrirDb();
  const registros = await requestToPromise(txStore(db, STORE_CLIENTES, "readonly").getAll());
  db.close();
  const filtro = normalizarTexto(texto || "a");
  return registros.filter(cliente => {
    if (!clienteCumpleTipo(cliente, tipoCliente)) return false;
    const telefono = cliente.telefonosClientesList && cliente.telefonosClientesList.length > 0 && cliente.telefonosClientesList[0].telefonosClientesPK ? cliente.telefonosClientesList[0].telefonosClientesPK.telefono : "";
    const valores = [
      cliente.nombre,
      cliente.codigo,
      cliente.cedrnc,
      cliente.nss,
      cliente.carnet,
      cliente.pasaporte,
      cliente.referencia,
      cliente.direccion,
      telefono,
    ].map(normalizarTexto);
    return valores.some(valor => valor.indexOf(filtro) >= 0);
  }).slice(0, 25);
}

export async function contarFacturasPendientes() {
  const pendientes = await obtenerFacturasPendientes();
  return pendientes.length;
}


export async function guardarArs(arsList) {
  const db = await abrirDb();
  const store = txStore(db, STORE_ARS, "readwrite");
  for (const ars of arsList || []) {
    if (ars && ars.codigo != null) {
      await requestToPromise(store.put(ars));
    }
  }
  db.close();
}

export async function buscarArsCache(texto) {
  const db = await abrirDb();
  const registros = await requestToPromise(txStore(db, STORE_ARS, "readonly").getAll());
  db.close();
  const filtro = normalizarTexto(texto || "");
  return registros.filter(ars => {
    const nombre = normalizarTexto(ars.nombre);
    const codigo = ars.codigo != null ? ars.codigo.toString() : "";
    const rnc = normalizarTexto(ars.rnc);
    return !filtro || nombre.indexOf(filtro) >= 0 || codigo.indexOf(filtro) >= 0 || rnc.indexOf(filtro) >= 0;
  }).slice(0, 50);
}

export async function guardarMensajeros(mensajeros) {
  const db = await abrirDb();
  const store = txStore(db, STORE_MENSAJEROS, "readwrite");
  for (const mensajero of mensajeros || []) {
    if (mensajero && mensajero.codigo != null) {
      const copia = Object.assign({}, mensajero, {
        sucursalKey: mensajero.sucursal && mensajero.sucursal.codigo != null ? mensajero.sucursal.codigo : 0,
      });
      await requestToPromise(store.put(copia));
    }
  }
  db.close();
}

export async function buscarMensajerosCache(sucursal) {
  const db = await abrirDb();
  const registros = await requestToPromise(txStore(db, STORE_MENSAJEROS, "readonly").getAll());
  db.close();
  return registros.filter(mensajero => mensajero.sucursalKey === 0 || mensajero.sucursalKey === sucursal);
}

export async function guardarTiposTarjeta(tiposTarjeta) {
  const db = await abrirDb();
  const store = txStore(db, STORE_TIPOS_TARJETA, "readwrite");
  for (const tipoTarjeta of tiposTarjeta || []) {
    if (tipoTarjeta && tipoTarjeta.codigo != null) {
      await requestToPromise(store.put(tipoTarjeta));
    }
  }
  db.close();
}

export async function buscarTiposTarjetaCache() {
  const db = await abrirDb();
  const registros = await requestToPromise(txStore(db, STORE_TIPOS_TARJETA, "readonly").getAll());
  db.close();
  return registros.sort((a, b) => normalizarTexto(a.nombre).localeCompare(normalizarTexto(b.nombre)));
}

export async function guardarVendedores(vendedores) {
  const db = await abrirDb();
  const store = txStore(db, STORE_VENDEDORES, "readwrite");
  for (const vendedor of vendedores || []) {
    if (vendedor && vendedor.codigo != null) {
      const copia = Object.assign({}, vendedor, {
        sucursalKey: vendedor.sucursal && vendedor.sucursal.codigo != null ? vendedor.sucursal.codigo : 0,
      });
      await requestToPromise(store.put(copia));
    }
  }
  db.close();
}

export async function buscarVendedoresCache(sucursal, texto) {
  const db = await abrirDb();
  const registros = await requestToPromise(txStore(db, STORE_VENDEDORES, "readonly").getAll());
  db.close();
  const filtro = normalizarTexto(texto || "");
  return registros
    .filter(vendedor => vendedor.sucursalKey === 0 || vendedor.sucursalKey === sucursal)
    .filter(vendedor => {
      if (!filtro) return true;
      const valores = [
        vendedor.nombre,
        vendedor.codigo,
        vendedor.codigo2,
        vendedor.cedula,
        vendedor.telefono,
      ].map(normalizarTexto);
      return valores.some(valor => valor.indexOf(filtro) >= 0);
    })
    .sort((a, b) => normalizarTexto(a.nombre).localeCompare(normalizarTexto(b.nombre)))
    .slice(0, 50);
}
